import axios from '@_system/axios/axios.js'
export default {
	path: '/wlnpurchase',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updatefromlist(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updatefromlist/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getPaycode(id,data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/getPaycode/'+id, data, (res) => {
				resolve(res.data)
			})
		})
	},
	getSettlement(id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getSettlement/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	getDetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getDetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	saveSettlement(id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/saveSettlement/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	deleteSettlement(id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/deleteSettlement/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	updateParcel(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updateParcel', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	reportgoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/reportgoods', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	takegoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/takegoods', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	synchronous(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/synchronous', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},		
	modifieddetail(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/modifieddetail', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},		
	getlabelid(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getlabelid', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/wlnpurchase.wlnpurchase', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	}
}
